import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { DomSanitizer } from '@angular/platform-browser'
import { MdIconRegistry, MdSlideToggleChange } from '@angular/material'

import { UserService } from '../../users/shared/user.service'
import { AuthService } from '../../auth/auth.service'
import { AudioService } from '../../shared/shared.module'
import { GeolocationService } from '../../geolocation/geolocation.module'

import { UserLocationService, User } from '../../users/users.module'

import { Observable } from 'rxjs/Observable'
import { Subscription } from 'rxjs/Subscription'
import { Subject } from 'rxjs/Subject'

@Component({
  selector: 'cm-settings',
  templateUrl: 'settings.component.html',
  styleUrls: ['settings.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsComponent implements OnInit, OnDestroy {

  public user: User
  public location: number[]
  public soundEnabled = true

  private subscription: Subscription

  private debouncer = new Subject<any>()

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private userLocationService: UserLocationService,
    private geolocationService: GeolocationService,
    private audioService: AudioService,
    private router: Router,
    private iconRegistry: MdIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'plane',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/img/icon/ic_plane_white.svg')
    )

    this.debouncer
      .debounceTime(700)
      .subscribe((user: User) => this.updatePreferences())
  }

  ngOnInit() {
    const uid = this.authService.currentUser.uid
    this.subscription = this.userService.getUser(uid)
      .subscribe((user: User) => this.user = user)

    this.soundEnabled = this.audioService.isSoundEnabled()

    this.getLocation(uid)
  }

  ngOnDestroy() {
    if (this.debouncer) {
      this.debouncer.unsubscribe()
    }

    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  private getLocation(uid: string) {
    this.userLocationService.getLocation(uid)
      .subscribe(latLng => {
        this.location = latLng
      })
  }

  changeLocation() {
    this.router.navigate(['location'])
  }

  updatePreferences() {
    const uid = this.user.uid
    const preferences = this.user.preferences

    this.userService.updatePreferences(uid, preferences)
  }

  setFollowMode() {
    const uid = this.user.uid

    if (this.user.preferences.follow) {
      return
    }

    this.geolocationService.getCurrentPosition()
      .subscribe(position => {
        this.userLocationService.setLocation(uid, position.coords.latitude, position.coords.longitude)
          .subscribe()

        this.location = [position.coords.latitude, position.coords.longitude]
        this.userService.updatePreferences(uid, {
          follow: true
        })
      })

    this.getLocation(uid)
  }

  debounceUpdatePreferences() {
    this.debouncer.next()
  }

  toggleSound(change: MdSlideToggleChange) {
    this.audioService.enableSound(change.checked)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/settings/settings.component.ts